var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactTitle"},_vm._l((_vm.dataList),function(item,index){return _c('span',{key:index,class:_vm.subNavIndex==index?'activeTitle':'',on:{"click":function($event){return _vm.goItemPage(item,index)}}},[_vm._v(_vm._s(item.menuName))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }